// Small curated BCP-47 list for the Sprachen requirement row.
// Genesis stores languageTag as a free string; this is a UX-only constraint
// to prevent typos. The list mirrors the most common languages on the
// platform; extend as needed.

export interface LanguageOption {
  tag: string;
  labelDe: string;
  labelEn: string;
}

export const LANGUAGES: LanguageOption[] = [
  { tag: "de", labelDe: "Deutsch", labelEn: "German" },
  { tag: "en", labelDe: "Englisch", labelEn: "English" },
  { tag: "fr", labelDe: "Französisch", labelEn: "French" },
  { tag: "es", labelDe: "Spanisch", labelEn: "Spanish" },
  { tag: "it", labelDe: "Italienisch", labelEn: "Italian" },
  { tag: "pt", labelDe: "Portugiesisch", labelEn: "Portuguese" },
  { tag: "nl", labelDe: "Niederländisch", labelEn: "Dutch" },
  { tag: "pl", labelDe: "Polnisch", labelEn: "Polish" },
  { tag: "tr", labelDe: "Türkisch", labelEn: "Turkish" },
  { tag: "ru", labelDe: "Russisch", labelEn: "Russian" },
  { tag: "uk", labelDe: "Ukrainisch", labelEn: "Ukrainian" },
  { tag: "ar", labelDe: "Arabisch", labelEn: "Arabic" },
  { tag: "zh", labelDe: "Chinesisch", labelEn: "Chinese" },
  { tag: "ja", labelDe: "Japanisch", labelEn: "Japanese" },
  { tag: "ko", labelDe: "Koreanisch", labelEn: "Korean" },
  { tag: "hi", labelDe: "Hindi", labelEn: "Hindi" },
  { tag: "cs", labelDe: "Tschechisch", labelEn: "Czech" },
  { tag: "sv", labelDe: "Schwedisch", labelEn: "Swedish" },
  { tag: "da", labelDe: "Dänisch", labelEn: "Danish" },
  { tag: "no", labelDe: "Norwegisch", labelEn: "Norwegian" },
  { tag: "fi", labelDe: "Finnisch", labelEn: "Finnish" },
  { tag: "el", labelDe: "Griechisch", labelEn: "Greek" },
  { tag: "hu", labelDe: "Ungarisch", labelEn: "Hungarian" },
  { tag: "ro", labelDe: "Rumänisch", labelEn: "Romanian" },
];
